import { useContext } from "react";
import { appContext } from "../../context/AppContext";
import { AccountPageSection } from "../../layouts/AccountPageSection";
import { Grid } from "@mui/material";
import Parcel from "single-spa-react/parcel";
import { isInternalTeamMember } from "../../hooks/useCheckAccess";

export function AccountDashboard(props) {
  const context = useContext(appContext);
  return (
    <AccountPageSection testId={"account-kpi-dashboard"} label={"Dashboards"}>
      <Grid item xs={12}>
        <Parcel
          config={() => System.import("@mytw/account-kpi-dashboard")}
          {...props}
          isInternalTeamMember={isInternalTeamMember(
            context.user.employeeNumber
          )}
          accountId={context.appConfig.accountId}
        />
      </Grid>
    </AccountPageSection>
  );
}
